<!-- order-table.component.html -->
<div class="table-responsive">
  <h2>Offene Stornoposten</h2>
  <mat-form-field>
    <mat-label>Kellner_in filtern</mat-label>
    <mat-select (selectionChange)="applyFilter($event.value)">
      <mat-option *ngFor="let waiter of waiterFilterValues" [value]="waiter">{{ waiter }}</mat-option>
    </mat-select>
  </mat-form-field>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
    <!-- Columns for Order interface -->
    <ng-container matColumnDef="waiter">
      <th mat-header-cell *matHeaderCellDef>Kellner_in</th>
      <td mat-cell *matCellDef="let position">{{ position.createdBy }}</td>
    </ng-container>

    <ng-container matColumnDef="itemName">
      <th mat-header-cell *matHeaderCellDef>Bezeichnung</th>
      <td mat-cell *matCellDef="let position">{{ position.itemName }}</td>
    </ng-container>

    <ng-container matColumnDef="singlePrice">
      <th mat-header-cell *matHeaderCellDef>Einzelpreis</th>
      <td mat-cell *matCellDef="let position">{{ position.singlePrice | currency: 'EUR': 'symbol' }}</td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef>Menge</th>
      <td mat-cell *matCellDef="let position">{{ position.quantity }}</td>
    </ng-container>

    <ng-container matColumnDef="totalAmount">
      <th mat-header-cell *matHeaderCellDef>Summe</th>
      <td mat-cell *matCellDef="let position">{{ position.itemTotalAmount | currency: 'EUR': 'symbol' }}</td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>Erstellt am</th>
      <td mat-cell *matCellDef="let position">{{ position.created | date: "dd.MM.yyyy HH:mm:ss" }}</td>
    </ng-container>

    <ng-container matColumnDef="accept">
      <th mat-header-cell *matHeaderCellDef>Akzeptieren</th>
      <td mat-cell *matCellDef="let position">
        <button mat-icon-button (click)="acceptCancellation(position.guid)">
          <mat-icon>done</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="decline">
      <th mat-header-cell *matHeaderCellDef>Ablehnen</th>
      <td mat-cell *matCellDef="let position">
        <button mat-icon-button (click)="declineCancellation(position.guid)">
          <mat-icon>close</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let position; columns: displayedColumns;"></tr>
  </table>
</div>
